import { useTranslation } from 'react-i18next';
import { DetailsListView, EntityGridListProps } from '../../Common/DetailsList/DetailListView';

export const CostPerHourGridListAje = (props: EntityGridListProps) => {
  const { t } = useTranslation();

  const columns = [
    {
      fieldName: 'periodo',
      name: t('Periodo'),
      minWidth: 20,
      maxWidth: 50,
    },
    {
      fieldName: 'col_nombre_completo',
      name: t('Nombre'),
      minWidth: 20,
      maxWidth: 100,
    },
    {
      fieldName: 'rcp_horas_cargadas',
      name: t('Horas cargadas'),
      minWidth: 20,
      maxWidth: 80,
    },
    {
      fieldName: 'rcp_costo_hora',
      name: t('Costo por hora'),
      minWidth: 20,
      maxWidth: 80,
    },
    {
      fieldName: 'rcp_coef_valor_agr',
      name: t('Coeficiente valor agregado'),
      minWidth: 20,
      maxWidth: 150,
    },
  ];
  return (
      <>
        <DetailsListView
            changeBlockUI={props.changeBlockUI}
            keyList={props.keyList}
            onClickCardMode={() => props.onClickCardMode()}
            onClickGridMode={() => props.onClickGridMode()}
            mode={props.mode}
            title={t('Costo por hora')}
            // virtualize={true}
            cols={columns}
            isGridList={true}
            courier={props.courier}
            listFilters={[]}
            quickFilters={props.quickFilters}
            onItemClick={props.onItemClick}
            baseUrl={props.baseUrl}
        ></DetailsListView>
      </>
  );
};
